// extracted by mini-css-extract-plugin
export default {"scrollbar":"AccountNav_scrollbar__vNyhl"};